import {
  CHANGE_CLIENT_ID,
} from "../actions/appConfig";

const initState = {
  clientId :""
}

export default function appConfig(state = initState, action) {
  switch (action.type) {
    case CHANGE_CLIENT_ID:
      return { ...state, clientId: action.clientId };
    default:
      return state;
  }
}
